export default __webpack_public_path__ + "static/media/LargeBreastedPutBraOnCorrectlyFinalCut.602053bd.png";